import { gql } from '@apollo/client';

export const REMOVE_FINANCIAL_PRODUCT = gql`
  mutation deleteFinancialProduct($input: DeleteFinancialProductInput) {
    deleteFinancialProduct(input: $input) {
      commandId
    }
  }
`;

export const DUPLICATE_FINANCIAL_PRODUCT = gql`
  mutation duplicateFinancialProduct($input: DuplicateFinancialProductInput) {
    duplicateFinancialProduct(input: $input) {
      commandId
    }
  }
`;
